import { RouteObject } from 'react-router';

import { lazyImport } from '@sternum/web/utils/lazyImport';

import { Layout } from './Layout.component';
import { integrationsPaths } from './paths';

const { CloudIntegration } = lazyImport(() => import('../views/cloud'), 'CloudIntegration');
const { DevicesIntegration } = lazyImport(() => import('../views/devices'), 'DevicesIntegration');

export const integrationsRoutes: RouteObject[] = [
  {
    path: integrationsPaths.absolute,
    element: <Layout />,
    children: [
      { path: integrationsPaths.cloud.relative, element: <CloudIntegration /> },
      { path: integrationsPaths.devices.relative, element: <DevicesIntegration /> },
    ],
  },
];
